const roundToTwo = (num: number): number =>
  Math.round((num + Math.sign(num) * Number.EPSILON) * 100) / 100;

export default roundToTwo;
